export default "__VITE_ASSET__Ci6ZomLJ__"